import * as t from "io-ts";

export const LocationMetaRelationshipEntityCodec = t.intersection([
  t.type({
    entityId: t.string,
    entityType: t.string,
    entityName: t.string,
  }),
  t.partial({
    entityAttributes: t.record(t.string, t.unknown)
  }),
]);

export const LocationMetaRelationshipEntityArrayCodec = t.array(
  LocationMetaRelationshipEntityCodec
);

export type LocationMetaRelationshipEntity = t.TypeOf<typeof LocationMetaRelationshipEntityCodec>;

export const LocationMetaRelationshipCodec = t.intersection([
  t.type({
    type: t.string,
    entity: LocationMetaRelationshipEntityCodec,
  }),
  t.partial({}),
]);

export const LocationMetaRelationshipArrayCodec = t.array(
  LocationMetaRelationshipCodec
);

export type LocationMetaRelationship = t.TypeOf<typeof LocationMetaRelationshipCodec>;
